import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import axios from 'axios';
import UserAccount from '../../../API/UserAccount';
import resx from '../../../utilities/resx';
import GeneralUtility from '../../../utilities/generalUtility';
import { RESX_GLOBAL } from '../../../Constants';
import { withMessage } from '../Message';

import ProfileSideBarImpl from './ProfileSideBarImpl';

const ProfileSideBar = ({ message }) => {
    let targetDomain;

    switch (window.pageType) {
        case 'listings-summary':
            targetDomain = window.decodeURIComponent(window.location.pathname).match('/*(.*)/listings')[1];
            break;
        case 'activity-feed':
            targetDomain = window.decodeURIComponent(window.location.pathname).match('/*(.*)/profile')[1];
            break;
        case 'one-to-one-referral-form':
            targetDomain = window.decodeURIComponent(window.location.pathname).match('/*(.*)/referral')[1];
            break;
        default:
            targetDomain = null;
            break;
    }
    const [targetUser, setTargetUser] = useState(false);
    useEffect(() => {
        if (!targetDomain) {
            return false;
        }
        const getProfile = UserAccount.getProfile({ domain: targetDomain });
        getProfile.request
            .then(response => {
                const user = {
                    canUserRefer: _path(['data', 'CanUserRefer'], response),
                    canUserConnect:
                        _path(['RESAAS', 'User2', 'IsProfessional'], window) ||
                        _path(['RESAAS', 'User2', 'LoggedInUserIsAdminOrStaff'], window),
                    isOwner: _path(['RESAAS', 'User2', 'UserId'], window) === _path(['data', 'UserId'], response),
                    websiteId: _path(['data', 'WebsiteId'], response),
                    userId: _path(['data', 'UserId'], response),
                    userFirstName: _path(['data', 'FirstName'], response),
                    userLastName: _path(['data', 'LastName'], response),
                    username: _path(['data', 'FullName'], response),
                    domainurl: `/${_path(['data', 'DomainUrl'], response)}`,
                    premiumPlus: _path(['data', 'UserHasPremiumPlusBadge'], response),
                    premiumUser:
                        _path(['data', 'UserHasProfileBadge'], response) ||
                        _path(['data', 'UserHasPremiumPlusBadge'], response),
                    userPhone: _path(['data', 'PhoneNumber'], response),
                    userWebsiteUrl: _path(['data', 'WebsiteUrl'], response),
                    office: {
                        name: _path(['data', 'Office', 'Name'], response),
                        address: _path(['data', 'Office', 'Address'], response),
                        city: _path(['data', 'Office', 'City'], response),
                        state: _path(['data', 'Office', 'State'], response),
                        postcode: _path(['data', 'Office', 'PostCode'], response),
                        phone: _path(['data', 'Office', 'Telephone'], response)
                    },
                    firm: {
                        FirmUniqueName: _path(['data', 'FirmUniqueName'], response),
                        HideFirmFeed: _path(['data', 'HideFirmFeed'], response),
                        HasFirmBranding: _path(['data', 'HasFirmBranding'], response),
                        FirmName: _path(['data', 'FirmName'], response),
                        FirmLogoUrl: _path(['data', 'FirmLogoUrl'], response),
                        FirmBrandColorHexCode: _path(['data', 'FirmBrandColorHexCode'], response),
                        FirmCSS: _path(['data', 'FirmName'], response),
                        OfficeCSS: _path(['data', 'WebsiteOfficeName'], response)
                    },
                    social: {
                        TwitterUrl: _path(['data', 'TwitterUrl'], response),
                        FacebookUrl: _path(['data', 'FacebookUrl'], response),
                        LinkedInUrl: _path(['data', 'LinkedInUrl'], response),
                        InstagramUrl: _path(['data', 'InstagramUrl'], response)
                    },
                    bioInfo: _path(['data', 'BioText'], response),
                    groups: _path(['data', 'TargetUserGroups'], response)
                };

                if (user.firm.FirmCSS) {
                    user.firm.FirmCSS = user.firm.FirmCSS.toLowerCase().replace(' ', '-');
                }
                if (user.firm.OfficeCSS) {
                    user.firm.OfficeCSS = user.firm.OfficeCSS.toLowerCase().replace(' ', '-');
                }
                setTargetUser(user);
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    return;
                }
                message.addMessage({ message: resx(RESX_GLOBAL, 'GENERIC_WEBSERVICE_ERROR_MESSAGE'), type: 'error' });
                GeneralUtility.logWebRequestFailure(error, `fetch target user profile info from ProfileSideBar`);
            });

        return () => {
            getProfile.cancel();
        };
    }, []);

    if (!targetUser) {
        return <React.Fragment></React.Fragment>;
    }
    return <ProfileSideBarImpl user={targetUser} />;
};
ProfileSideBar.propTypes = {
    message: PropTypes.object
};

export default withMessage(ProfileSideBar);
